import { useEffect } from 'react';
import { CHECKOUT_URL, MP_WEBAPP_RESOURCE_PARAM } from '../utils/constants';
import { getVisitorLocation } from '../utils/visitorLocation';

const redirectToCheckout = async ({ plan, paymentInterval, units, packages, packageVersion }) => {
	const { locale, region } = await getVisitorLocation();

	const url = new URL(CHECKOUT_URL);

	url.searchParams.append('edition', plan);
	url.searchParams.append('packageSize', units);
	packages.length && url.searchParams.append('additionalPackages', packages.join(','));
	url.searchParams.append('paymentInterval', paymentInterval);
	url.searchParams.append('region', region);
	url.searchParams.append('language', locale);
	url.searchParams.append('packageVersion', packageVersion);

	// 'buyFromApplication' parameter
	const locationSearchParams = new URLSearchParams(window.location.search);
	locationSearchParams.has(MP_WEBAPP_RESOURCE_PARAM) && url.searchParams.append('buyFromApplication', 'true');

	location.assign(url.href);
};

export const useRedirectToCheckout = (packageVersion, consulting_packages, userData) => {
	useEffect(() => {
		if (!packageVersion || !consulting_packages || !userData || userData.step !== 3) {
			return;
		}

		redirectToCheckout({
			plan: userData.plan,
			paymentInterval: userData.paymentInterval,
			units: userData.units,
			packages: userData.packages.map((id) => consulting_packages.find((cPackage) => cPackage.ID === id).key),
			packageVersion,
		});
	}, [userData.step]);
};
